import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { organization, branding } from "../../config";

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Montserrat', sans-serif",
        textAlign: "center",
        padding: "40px 20px",
      }}
    >
      <Helmet>
        <title>Page Not Found | {organization.name}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <h1
        style={{
          fontSize: "6rem",
          fontWeight: "700",
          color: branding.primaryColor,
          marginBottom: "10px",
          lineHeight: "1",
        }}
      >
        404
      </h1>
      <h2
        style={{
          fontSize: "1.5rem",
          fontWeight: "600",
          color: "#333",
          marginBottom: "20px",
        }}
      >
        Page Not Found
      </h2>
      <p
        style={{
          fontSize: "1.1rem",
          color: "#666",
          maxWidth: "500px",
          marginBottom: "30px",
          lineHeight: "1.6",
        }}
      >
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", justifyContent: "center" }}>
        <Link
          to="/"
          className="btn btn-custom-filled"
          style={{
            padding: "12px 30px",
            fontSize: "1rem",
            fontWeight: "600",
          }}
        >
          Go to Homepage
        </Link>
        <Link
          to="/contact"
          className="btn btn-custom-outline"
          style={{
            padding: "12px 30px",
            fontSize: "1rem",
            fontWeight: "600",
          }}
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
}
